<script>
export default {
    name: 'IconFacebookLight',
}
</script>
<template>
    <svg class="base-icon icon-facebook-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M34.143 24.889H50L48.238 32H34.143v32h-7.048V32H13v-7.111h14.095v-6.656c0-6.34.656-8.64 1.882-10.958a12.868 12.868 0 0 1 5.328-5.376C36.602.66 38.882 0 45.165 0c1.84 0 3.454.178 4.835.533v6.578h-4.835c-4.665 0-6.085.278-7.534 1.06a5.76 5.76 0 0 0-2.438 2.46c-.775 1.461-1.05 2.894-1.05 7.602v6.656Z" clip-rule="evenodd"/></svg>
</template>